<template>
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.8333 8.33333V11.6667H15.8333V8.33333H10.8333ZM9.16667 8.33333H4.16667V11.6667H9.16667V8.33333ZM10.8333 15.8333H15.8333V13.3333H10.8333V15.8333ZM9.16667 15.8333V13.3333H4.16667V15.8333H9.16667ZM10.8333 4.16667V6.66667H15.8333V4.16667H10.8333ZM9.16667 4.16667H4.16667V6.66667H9.16667V4.16667ZM15.8333 2.5C16.7538 2.5 17.5 3.24619 17.5 4.16667V15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H4.16667C3.24619 17.5 2.5 16.7538 2.5 15.8333V4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H15.8333Z"
      fill="#16A34A"
    />
  </svg>
</template>
